var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",staticClass:"modal overlay",class:{
    'modal-intro-animation': _vm.startModalIntroAnimation,
    'show-full-modal': _vm.showFullModal,
  }},[_c('hr',{staticClass:"pull-line"}),_c('PrimaryImageOnlyBaseCta',{staticClass:"hidden md:block absolute top-[62px] right-12",attrs:{"image":"icons/close_black.svg","type":"tertiary"},on:{"click":_vm.internalClose}}),_c('div',{staticClass:"min-h-[200px]"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }